import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {AuthBankAccountParam} from '../../common/shared/api/billing/vo/AuthBankAccountParam.interface';
import type {AuthBankAccountResultVo} from '../../common/shared/api/billing/vo/AuthBankAccountResultVo.interface';

/**
 * 계좌 인증
 *
 * Origin: pageBillingApi.authBankAccount
 * API: POST /v1/dkpg/auth-bank-account
 */
export async function postBillingDkpgAuthBankAccount(
  params: AuthBankAccountParam,
  options?: FetcherOptions
): Promise<AuthBankAccountResultVo> {
  const response = await axiosBffFetch(
    '/api/billing/v1/dkpg/auth-bank-account',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(params),
    },
    options
  );

  return response.data;
}
